/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 764
// module chunks = 1